// extracted by mini-css-extract-plugin
module.exports = {"radar":"index_radar-1FPjx","legend":"index_legend-1kSGR","legendItem":"index_legendItem-3ksgs","dot":"index_dot-cjsOO"};